<template>
  <div id="forgotPassword">
    <b-modal
      ref="forgot_password_modal"
      id="forgot_password_modal"
      size="md"
      :okTitle="$t('home.forgot_password.ok_title')"
      @show="resetModal"
      @hidden="resetModal"
      @ok="clickSend"
    >
      <!-------------
      MODAL HEADER
      -------------->
      <template #modal-header="{ close }">
        <h5>{{ $t("home.forgot_password.forgot_password") }}</h5>
        <b-button size="sm" variant="none" @click="close()">
          <i class="fas fa-times"></i>
        </b-button>
        <span class="lock">
          <i class="fas fa-user-unlock"></i>
        </span>
      </template>

      <!-------------
      MODAL BODY
      -------------->
      <div class="resetPassword" v-if="!posting && !done">
        <p class="text-left mb-2 mt-2">{{ $t("home.forgot_password.modal_text") }} <br /></p>

        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            :state="nameState"
            :label="$t('home.forgot_password.your_email')"
            label-for="email-input"
            :invalid-feedback="$t('home.forgot_password.valid_email_required')"
          >
            <b-form-input ref="email" autofocus id="email-input" type="email" v-model="email" :state="nameState" required></b-form-input>
          </b-form-group>
        </form>
      </div>

      <div class="posting text-center" v-if="posting">
        <b-col cols="12" class="register p-4" v-if="posting">
          <img width="150" src="../../assets/image/loader/logoLoading.gif" alt="" />
          <div class="mt-3 loaderText">{{ $t("home.forgot_password.please_wait") }}</div>
        </b-col>
      </div>

      <div class="resetConfirm" v-if="done">
        {{ $t("home.forgot_password.email_sent_1") }} <strong>{{ email }}</strong>,
        {{ $t("home.forgot_password.email_sent_2") }}
      </div>

      <!-------------
      MODAL FOOTER
      -------------->
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button v-show="!done" variant="success" size="md" class="btn-block" @click="clickSend">
            {{ $t("home.forgot_password.send_email") }}
          </b-button>

          <b-button variant="primary" size="md" class="float-right mr-2" @click="closeModal" v-if="done">
            {{ $t("home.forgot_password.ok") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { methodMixin } from "@/mixins/methodMixin.js";

export default {
  name: "ResetPasswordModal",
  mixins: [methodMixin],
  components: {},
  data() {
    return {
      posting: false,
      done: false,
      email: "",
      nameState: null,
      submittedNames: []
    };
  },
  created() {
    //this.$ga.page("/modal/reset_password");
  },
  destroyed() {
    this.resetModal();
  },
  methods: {
    closeModal() {
      this.$refs["forgot_password_modal"].hide();
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.email = "";
      this.done = false;
      this.posting = false;
      this.nameState = null;
    },
    clickSend(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      this.posting = true;
      const response = this.backend_request("/api/user/reset/password/request", { email: this.email }, "post");
      response
        .then(response => {
        })
        .catch(error => {
        });
      this.posting = false;
      this.done = true;

      this.$ga.event({
        eventCategory: 'Login',
        eventAction: 'Forgot Password',
        eventLabel: this.email,
        // eventValue: 1
      });

      // Push the name to submitted names
      // this.submittedNames.push(this.name)
      // Hide the modal manually
      // this.$nextTick(() => {
      //   this.$bvModal.hide('modal-prevent-closing')
      // })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form-control {
  border: 1px solid #cecfcf;
  border-radius: 3px;
  &:focus {
    border: 1px solid #9c9a9a;
  }
}

.form-group {
  margin-bottom: 0.5rem;
}

::v-deep .modal-content {
  padding-bottom: 0.75rem;
  overflow: hidden;
}

::v-deep .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: none !important;
  padding: 1.5rem 1rem;
  background-color: #FFED61;
  margin-bottom: 1.75rem;
  .lock {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #28a745;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 1.25rem;
    i {
      color: #fff;
    }
  }
  button {
    color: #a79429;
    font-size: 1.25rem;
    transform: translateY(-5px);
    &:hover {
      color: #70610b;
    }
  }
}

::v-deep .modal-body {
  padding-top: 0;
  padding-bottom: 0;
}


::v-deep label {
  font-weight: 500;
}


::v-deep .modal-footer {
  padding-top: 0;
  border-top: none !important;
}
</style>
